import { useMemo } from 'react'
import { NetworkStatus, useQuery } from '@apollo/client'

import { DebitCardProductType } from 'types/gql-global-types'
import {
  GetCorporateCardsList as GetCorporateCardsListType,
  GetCorporateCardsList_getDebitCardsV2_cards as CorporateCard,
  GetCorporateCardsListVariables,
} from 'types/gql-types/GetCorporateCardsList'

import { GetCorporateCardsList } from './graphql/getCorporateCardsList'
import { useToggleHeaderButtons } from './useToggleHeaderButtons'

const getFilteredCorporateCards = (cards: (CorporateCard | null)[]) => {
  return cards.filter((card): card is CorporateCard => !!card)
}

export const useQueryCorporateCards = () => {
  const {
    loading,
    data,
    error,
    networkStatus,
    refetch: refetchCards,
  } = useQuery<GetCorporateCardsListType, GetCorporateCardsListVariables>(
    GetCorporateCardsList,
    {
      variables: {
        filter: {
          productType: {
            eq: DebitCardProductType.EXPENSE,
          },
        },
      },
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
    }
  )

  const cards = useMemo(
    () => getFilteredCorporateCards(data?.getDebitCardsV2?.cards ?? []),
    [data]
  )

  useToggleHeaderButtons({ cards })

  const entity = useMemo(() => data?.getEntity ?? null, [data?.getEntity])

  return {
    isLoading: loading || networkStatus === NetworkStatus.refetch,
    cards,
    entity,
    error,
    refetchCards,
  }
}
